import * as React from 'react';
import clsx from 'clsx';
import { Svg } from '@gandi/ui';
var styles = {
  "root": "Header-root_xSqeg",
  "controls": "Header-controls_24FKB",
  "logo": "Header-logo_1tPUM",
  "toggle": "Header-toggle_1Sf_z",
  "widgets": "Header-widgets_2TvZw"
};
function Header(_ref) {
  var className = _ref.className,
    children = _ref.children,
    hrefLogo = _ref.hrefLogo,
    toggleNavigation = _ref.toggleNavigation,
    isNavigationExpanded = _ref.isNavigationExpanded;
  var handleClickToggle = function handleClickToggle(evt) {
    evt.preventDefault();
    toggleNavigation();
  };
  return /*#__PURE__*/React.createElement("header", {
    role: "banner",
    className: clsx(styles.root, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.controls
  }, /*#__PURE__*/React.createElement(Toggle, {
    isNavigationExpanded: isNavigationExpanded,
    onClick: handleClickToggle
  }), /*#__PURE__*/React.createElement("a", {
    href: hrefLogo,
    className: styles.logo
  }, /*#__PURE__*/React.createElement(Svg, {
    name: "gandi",
    title: "\\o/ Gandi.net",
    theme: "green"
  }))), children ? /*#__PURE__*/React.createElement("div", {
    className: styles.widgets
  }, children) : null);
}
var Toggle = function Toggle(props) {
  return /*#__PURE__*/React.createElement("a", {
    className: styles.toggle,
    href: "?navigation=".concat(props.isNavigationExpanded ? 'false' : 'true'),
    onClick: props.onClick
  }, /*#__PURE__*/React.createElement(Svg, {
    name: props.isNavigationExpanded ? 'arrowLeft' : 'hamburger',
    theme: "green"
  }));
};
export default Header;